<template>
  <div id="personal">
    <div class="body">
      <div class="left">
        <div class="info">
          <div class="email">
            {{ $store.state.userInfo.email }}
          </div>
          <div class="balance">
            <div class="b">
              <span class="f">$</span>
              <span class="num">
                {{ ((userInfo.balance || 0) * 1).toFixed(2) }}
              </span>
            </div>
            <div class="tip">当前余额</div>
            <el-button class="charge" type="primary" @click="recharge">充值</el-button>
          </div>
        </div>
        <div class="personal_nav">
          <div class="aNav" :class="{active: $route.path === '/orderHistory'}" @click="toOrderList"><span class="str">我的订单</span></div>
          <div class="aNav" :class="{active: $route.path === '/invite'}" @click="toInvite"><span class="str">邀请其他人</span></div>
          <!-- <div class="nav" @click="toPay">充值记录</div> -->
        </div>
      </div>
      <router-view class="right" />
      <!-- <div class="right">
        <router-view />
      </div> -->
    </div>

    <!-- <header class="personal_header">
      <div class="personal_logo">LOGO蝉鸣</div>
      <div class="personal_info">
        <div>账户： {{ userInfo.email }}</div>
        <div>当前余额： ${{ userInfo.balance || 0 }} <a href="#">充值</a></div>
      </div>
      <div class="personal_nav">
        <div class="nav" @click="toOrderList">我的订单</div>
        <div class="nav" @click="toInvite">邀请其他人</div>
      </div>
    </header>
    <section class="section">
      <router-view />
    </section>
    <div class="firstBox" v-if="isFirst">
      <div class="box">
        <div class="title">
          <h1>欢迎使用蝉鸣</h1>
        </div>
        <div>{{ $store.state.userInfo.email }} 您好</div>
        <div>欢迎登录蝉鸣，$300奖励金已到账请查收！</div>
        <div>
          <button @click="isFirst = false">确定</button>
        </div>
      </div>
    </div> -->

  </div>
</template>

<style lang="scss">
#personal {
   background: #F6F6F6;
   padding-top:15px;
  .body{
     margin:auto;
      display: flex;
      max-width:1200px;
  }
  .left {
    width: 200px;
    padding-right: 15px;
    .info {
       background:#fff;
       padding:15px 10px;
      .email {
        background: url("../assets/img2/info.png") no-repeat center top;
        padding-top: 85px;
        font-size: 12px;
        color: #999;
        text-align: center;
      }
      .balance {
         margin-top:25px;
        text-align: center;
        .b {
          .f {
            font-size: 12px;
          }
          .num {
             font-size: 20px;
            display: inline-block;
            font-weight: bold;
          }
        }
        .tip {
          font-size: 12px;
          color: #999;
        }
        .charge{
           margin-top:25px;
        }
      }
    }
    .personal_nav {
      margin-top: 15px;
      background: #fff;
      .aNav {
        height: 60px;
        line-height: 60px;
        color: #333;
        cursor: pointer;
        &:hover{
          .str{
             color: #3fb8a4;
          }
        }
        &.active {
          .str{
             color: #3fb8a4;
             font-weight: bold;
          }
          &:before {
            background: linear-gradient(333deg, #007791 0%, #3fb8a4 100%);
          }
        }
        &:before {
          content: " ";
          display: inline-block;
          width: 5px;
          height: 21px;
          background: transparent;
          vertical-align: middle;
          // background: linear-gradient(333deg, #007791 0%, #3FB8A4 100%);
        }
        .str{
           display:inline-block;
            vertical-align: middle;
            padding-left: 15px;
        }
      }
    }
  }
  .right {
    flex-grow:1;overflow: hidden;width: calc(100% - 200px);
  }

  .firstBox {
    position: fixed;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    .box {
      transition: all 0.5s;
      text-align: center;
      text-align: center;
      background: #fff;
      padding: 15px;
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    }
  }
}
@media screen and (max-width: 600px){
    #personal{
      .body{
         flex-direction: column;
         .left{
           width: 100%;
           padding-left:0;
           padding-right:0;
         }
         .right{
           width: 100%;
           padding-left:0;
           padding-right:0;
         }
      }
    }
}
</style>


<script>
import recharge from "@/public/method/recharge";

export default {
  data() {
    return {
      isFirst: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || {};
    },
  },
  methods: {
    toOrderList() {
      this.$router.push("/orderHistory");
    },
    toInvite() {
      this.$router.push("/invite");
    },
    recharge
  },
  created() {
     console.log("this.$route",this.$route.path)
    if (this.$store.state.isRegister) {
      this.isFirst = true;
      this.$store.state.isRegister = false;
    }
  },
};
</script>